import { FormControl } from '@angular/forms';

export enum Salutation {
    birthName,
    birthNameAndPartnerName,
    partnerNameAndBirthName
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Salutation {
    export function keys(): Array<keyof typeof Salutation> {
        const _keys = Object.keys(Salutation) as Array<keyof typeof Salutation>;
        return _keys.slice(_keys.length / 2 + 1, _keys.length - 1);
    }
}

export class PartnerDetails {
    public salutation: Salutation = Salutation.birthName;
    public partnerInsertion: string;
    public partnerLastName: string;
}

export interface PartnerDetailsForm {
    usePartnerName: FormControl<boolean>;
    salutation: FormControl<number>;
    partnerInsertion: FormControl<string>;
    partnerLastName: FormControl<string>;
}
